<template>
	<div>
		<div class="page" style="padding-top: 20px;">
			<h1 class="top-title" v-if="info && info.config">
				{{ info.config.exam_name }}
			</h1>
			<div class="text" style="margin-top: 20px;">
				<span v-for="(item,index) in info.score_arr" style="padding-right:15px;">
					你的{{ item.subject }}成绩为：<span class="score">{{ item.subject_score }}</span>
				</span>
			</div>
			<div class="text" style="margin: 20px 0;">具体而言，试题分析如下</div>
			<!-- <div>{{info.wrong_ids}}</div> -->
			<div style="font-size: 16px;font-weight: 600;display: flex;flex-wrap: wrap;padding:10px 0;"
				v-for="(item,index) in info.wrong_arr">
				{{item.subject}}错误的题号有:
				<span v-for="(v,i) in item.ids">&nbsp{{v}}{{i < item.ids.length-1 ? ',' : ''}}</span>
			</div>
			<div style="padding:30px 0;border-bottom: 1px solid #eee;" v-for="(item, index) in info.question_list"
				:key="index">
				<div style="display: flex;">
					<h2 style="padding-top:0px">{{index+1}}、</h2>
					<el-image style="width: 96%;" v-if="item.question_type == 1" @click="imgChange(item.question)"
						:src="item.question" fit="scale-down"></el-image>
					<div v-show="item.question_type == 2" v-html="item.question"
						style="font-size: 16px !important;padding: 20px;line-height: 1.75;">
					</div>
				</div>
				<div style="font-size: 16px;padding-top:10px;">
					<span>正确答案:{{ item.answer }}</span>
					<span style="margin-left:30px;">你的作答:<span
							:style="!item.question_bool ? 'color:red' : ''">{{ item.user_answer }}</span></span>
				</div>
				<div style="display: flex;margin-top: 20px;" :style="!item.question_analys ? 'align-items: center;' : ''">
					<div style="font-size: 16px;">答案解析:</div>
					<el-image style="width: 90%;" v-if="item.question_analys" @click="imgChange(item.question_analys)"
						:src="item.question_analys" fit="scale-down"></el-image>
					<div style="padding-left:10px;text-align: center;font-size: 17px;" v-if="!item.question_analys">无</div>
				</div>
			</div>
			<!-- <div class="content-item-table">
				<table class="table-self">
					<tr>
						<th style="width: 6%;">题号</th>
						<th style="width: 35%;">题目</th>
						<th style="width: 12%;">正确答案</th>
						<th style="width: 12%;">你的作答</th>
						<th style="width: 35%;">解析</th>
					</tr>
					<tr v-for="(item, index) in info.question_list" :key="index">
						<td style="border-right: 0.5px solid black;">{{ index+1 }}</td>
						<td>
							<img @click="imgChange(item.question)" style="width: 90%;height: 85px;" :src="item.question"
								alt="题目" />
						</td>
						<td style="font-size: 14px;">{{ item.answer }}</td>
						<td style="font-size: 14px;" :style="!item.question_bool ? 'color:red' : ''">
							{{ item.user_answer }}
						</td>
						<td>
							<img @click="imgChange(item.question_analys)" style="width: 90%;height: 85px;"
								:src="item.question_analys" alt="解析" />
						</td>
					</tr>
				</table>
			</div> -->
		</div>
		<el-dialog :visible.sync="showImg" width="50%">
			<el-image style="width: 100%;" :src="imgUrl" fit="scale-down"></el-image>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				info: {},
				imgUrl: '',
				showImg: false,
			}
		},
		mounted() {
			this.getResult();
		},
		methods: {
			print() {
				window.print();
			},
			getResult() {
				let phone = this.$route.query;
				let params = {
					phone: phone.phone
				}
				this.$request.post('/sike.php/analys/examResult', params).then((res) => {
					if (res.code == 200) {
						let info = res.data;
						this.info = info;
					}
				})
			},
			imgChange(item) {
				this.imgUrl = item;
				this.showImg = true;
			}
		}
	}
</script>
<style scoped>
	@media print {
		.no-print {
			display: none;
		}
	}

	.print-button {
		position: fixed;
		top: 200px;
		right: 20px;
	}

	html,
	body {
		margin: 0;
		padding: 0;
		font-family: Roboto, -apple-system, San Francisco, Segoe UI, Helvetica Neue, sans-serif;
		font-size: 12pt;
		background-color: #eee
	}

	* {
		box-sizing: border-box;
		-moz-box-sizing: border-box
	}

	.page {
		margin: 1cm auto;
		background: #fff;
		box-shadow: 0 4px 5px #4b4b4b33;
		outline: 0
	}

	div.page-break {
		page-break-after: always
	}

	h1 {
		page-break-before: always
	}

	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		page-break-after: avoid
	}

	p {
		margin: 0
	}

	p+p {
		margin-top: .5cm
	}

	a {
		text-decoration: none;
		color: #000
	}

	table {
		page-break-inside: avoid
	}

	@page {
		orphans: 4;
		widows: 2
	}

	@media print {

		html,
		body {
			background-color: #fff
		}

		.page {
			width: initial !important;
			min-height: initial !important;
			margin: 0 !important;
			padding: 0 !important;
			border: initial !important;
			border-radius: initial !important;
			background: initial !important;
			box-shadow: initial !important;
			page-break-after: always
		}
	}

	.page {
		width: 21cm;
		/* min-height: 29.7cm; */
		/* max-height: 29.7cm; */
		padding: .5cm
	}

	@page {
		size: A4 portrait;
		margin: 2cm
	}

	.top-logo {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center
	}

	.top-logo-img {
		width: 160px
	}

	.top-title {
		text-align: center;
		font-size: 26px;
		font-weight: 600;
		margin: 40px 0;
		line-height: 50px
	}

	.top-tip {
		box-shadow: 0 2px 6px 2px rgb(153, 153, 153);
		border-radius: 10px;
		overflow: hidden;
		margin: 0 10px 50px
	}

	.top-tip-title {
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #409eff;
		height: 40px;
		font-size: 15px;
		font-weight: 500;
		color: #fff
	}

	.top-tip-content {
		padding: 5px 10px;
		font-size: 14px;
		line-height: 30px;
		border-top: none;
		border-radius: 0 0 10px 10px;
		background-color: #fafafa
	}

	@media screen and (max-width: 768px) {
		.top-tip-content {
			font-size: 12px;
			line-height: 14px
		}
	}

	.index-img {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		margin-top: 10px;
		overflow: hidden
	}

	.index-img-graph {
		width: 400px
	}

	.content {
		margin-top: 40px
	}

	.content-item {
		margin-top: 50px
	}

	.content-item-title {
		text-align: center;
		font-size: 18px;
		font-weight: 600;
		color: #409eff;
	}

	.content-item-table {
		margin-top: 20px
	}

	.table-title {
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #409eff;
		color: #fff;
		height: 40px;
		font-size: 16px;
		font-weight: 400
	}

	.table-self {
		table-layout: fixed;
		border-collapse: collapse;
		width: 100%
	}

	.table-self th {
		font-size: 13px;
		font-weight: 500;
		border: 1px solid black;
		height: 30px
	}

	.table-self td {
		font-size: 12px;
		font-weight: 500;
		border: 1px solid black;
		text-align: center;
		height: 40px
	}

	.top-tips {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		color: #a3a3a3;
		margin: 10px 0 10px
	}

	.hello {
		font-size: 16px;
		display: flex;
		font-weight: 600;
		align-items: baseline;
		justify-content: center;
		font-family: å¾®è½¯é›…é»‘
	}

	.chart {
		height: 100vh
	}

	.hello-name {
		font-size: 25px;
		color: #409eff;
		font-weight: 600;
		margin-right: 6px
	}

	.text {
		font-size: 16px;
		font-weight: 700;
		display: flex;
		align-items: baseline;
		justify-content: center
	}

	.primary-text {
		color: #409eff;
		margin: 0 5px
	}

	.tip-text {
		color: #FF917C;
		margin: 0 5px
	}

	.subject-tag {
		margin-right: 10px
	}

	.score {
		font-size: 26px;
		font-weight: 700;
		color: #FF917C;
		margin: 0 5px
	}

	.chart-title {
		color: gray;
		text-align: center;
		margin-bottom: -20px;
		font-size: 14px
	}

	.star {
		display: flex;
		padding-left: 40px;
		align-items: center
	}

	.table1-tips {
		margin-left: 10px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center
	}

	.table1-tip {
		margin-top: 5px;
		display: flex;
		align-items: center
	}

	.table-1 td {
		height: 28px
	}

	.table-2 td {
		height: 60px
	}

	.table-2 {
		margin-bottom: 20px
	}

	.table-3 td {
		height: 40px
	}

	.table-3 {
		margin-bottom: 20px
	}

	.print-pdf {
		position: absolute;
		top: 20px;
		right: 20px
	}
</style>